/**
 * @returns {careHost} based on environment.
 */
export default function careHost() {
    const careUrl = process.env.CARE_HOST;
    return careUrl;
}
